module.exports = __webpack_public_path__ + "static/cypress-c9452e28f2a35bd4cbd1dd92fe9fe816.png";